<template>
<div>
  <modal v-if="creating" title="New KPI" btn="Save" @submit="createKPI" @close="close">
    <h-input label="What's the name of the KPI?" type="text" v-model="newKPI.name" required/>
  </modal>
  
  <modal v-if="!creating" title="Saved" btn="Close" @submit="close">
    You're all set! We'll start asking you about this metric on your daily
    reflections. 
  </modal>
  </div>
</template>

<script>
import modal from "@/components/modal/default";
import dataStore from "@/services/api/store";
import User from "@/services/api/authUser";
import snackhub from "@/services/hubs/snackbar";
import editKpi from "./editKPI";

const KPI_STORE = "ClientKPI";

export default {
  components: { modal, editKpi },
  data() {
    return {
      newKPI: {},
      creating: true
    };
  },
  created() {
    dataStore.findAll(KPI_STORE, {limit: 500})
      .then(kpis => {
        this.kpis = kpis;
      });
  },
  methods: {
    changeDisplay() {
      this.track_kpis = User.track_kpis;
      this.display = true;
    },
    createKPI() {
      this.creating = false;
      dataStore.create(KPI_STORE, this.newKPI).then(d => {
        this.$emit("newKPI", d);
        this.newKPI = {};
        // this.kpis = [...this.kpis, d];
        snackhub.update("created");
      });
    },
    destroy(id) {
      this.kpis = this.kpis.filter(k => k.id !== id);
      this.$emit("remove", id);
      snackhub.update("Deleted");
      dataStore.destroy(KPI_STORE, id);
    },
    close() {
      this.newKPI = {};
      this.creating = true;
      this.$emit("close");
      // if (this.newKPI.name && !this.error) {
      //   this.confirm = true;
      //   return;
      // }
      // this.confirm = false;
      // let user = true;
      // if (User.track_kpis !== this.track_kpis) {
      //   User.track_kpis = this.track_kpis;
      //   user = User.save({ track_kpis: this.track_kpis });
      // }

      // Promise.all([user, ...this.kpis.map(k => k.save())]).then(() => this.$emit("refresh"))
      // this.display = false;
    },
    update() {
      this.$emit("refresh");
    }
  }
};
</script>
